import AppPageWrapper from "./AppPageWrapper";

export default function NotPlannedPage() {
  return (
    <AppPageWrapper showNotPlannedBanner>
      <></>
    </AppPageWrapper>
  );
}
